import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { ReportPage } from '../reports/ReportPage';
import { loadReport } from '../reports/reportLoaders';
import type { TemplateContext } from '../reports/mustache';

/**
 * Premium report route — a shareable preview of the sheet.
 *
 * Not the primary way to get a PDF: the button on the result screen exports
 * directly without coming here. This route exists so a report can be opened
 * from a link, and it renders the same template the export produces.
 */
export default function PremiumAnalysisPDFPage(): React.JSX.Element {
  const { id } = useParams<{ id: string }>();

  const load = useCallback(async (): Promise<TemplateContext | null> => {
    if (!id) return null;
    const report = await loadReport('premium', id);
    return report?.viewModel ?? null;
  }, [id]);

  return (
    <ReportPage
      kind="premium"
      load={load}
      title={`kivo-premium-report-${(id ?? '').slice(0, 8).toUpperCase()}`}
    />
  );
}
